import React, { useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import { addClass } from '../../utils';
import './index.scss';
const SimpleLayout = () => {
  useEffect(() => {
    addClass();
  }, []);
  return (
    <>
      <Outlet />
    </>
  );
};

export default SimpleLayout;
